export default "__VITE_ASSET__928519fb__"